<div #tableContainer class="table-container" [ngClass]="{'table-wrapper': enableBorder}">
  <div *ngIf="hasTitle" class="table_title_header">
    <div class="table_title_container">
      <div #tableTitleContainer class="table_title_content mb-2" [id]="id+'-title'">
        <ng-content select="h1, h2, h3, h4, h5, h6"></ng-content>
        <ng-content select="span"></ng-content>
        <span class="table_title text--300" *ngIf="displayItemCount">
          &#40;{{ totalItems ?? primaryCount }}{{(shouldDiplayItemNameOnTotal && itemName != "") ? " ": ""}}{{shouldDiplayItemNameOnTotal ? (itemName | translate) : "" }}&#41;
        </span>
      </div>
      <ng-content select="div"></ng-content>
      <div *ngIf="secondaryCounts.size > 0" class="table_secondary_count_container">
        <span *ngFor="let item of secondaryCounts | keyvalue" class="table_secondary_count text text--400">
          {{ item.value + " " + (item.key | translate) }}
        </span>
      </div>
    </div>
    <div>
      <div class="align_end">
        <div class="row">
          <button *ngIf="hasMainActionButton" (click)="onMainActionClicked()" class="table_main_action mr-4" [color]="useSecondaryButton ? 'secondary' : 'primary'"
                  [disabled]="hasMainActionButtonDisabled" valgButton>
            {{ mainActionName | translate }}
          </button>
          <button *ngIf="hasSecondaryActionButton" (click)="onSecondaryActionClicked()" class="table_main_action" [color]="useSecondaryButton ? 'secondary' : 'primary'"
                  [disabled]="hasSecondaryActionButtonDisabled" valgButton>
            {{ secondaryActionName | translate }}
          </button>
        </div>
        <span [id]="id+'-description'" *ngIf="description">
          {{ description | translate}}
        </span>
      </div>
    </div>
  </div>
  <ng-content select="[content-position=pre-table]" class="pre-table"></ng-content>
  <div *ngIf="hasAction()" class="table_secondary_action">
    <div *ngIf="hasSearchBox && searchFields.length === 0" class="filter_search" [class.wide]="searchWidth === 2" [class.medium]="searchWidth === 1">
      <mat-icon [svgIcon]="SvgIcon.Search" class="filter_search__icon"></mat-icon>
      <input
        (keyup)="onSearchInputChange($event.target)"
        attr.aria-label="{{ (searchPlaceHolder ?? 'table.search_place_holder') | translate }}"
        class="filter_search__input text text--400"
        placeholder="{{ (searchPlaceHolder ?? 'table.search_place_holder') | translate }}"
      />
    </div>
    <ng-container *ngIf="!lazySearch">
      <div *ngFor="let searchField of searchFields" class="filter_search" [class.wide]="searchWidth === 2">
        <mat-icon [svgIcon]="SvgIcon.Search" class="filter_search__icon"></mat-icon>
        <input
                (keyup)="onSearchInputChange($event.target, searchField)"
                attr.aria-label="{{ searchField.label }}"
                class="filter_search__input text text--400"
                placeholder="{{ searchField.label }}"
        />
      </div>
    </ng-container>
    <ng-container *ngIf="lazySearch">
      <valg-input-group *ngFor="let searchField of searchFields, let i = index" class="table-input-group mr-5" [enableClear]="true" (onClear)="clearSearch(searchField)">
        <input
                #searchInputs
                valgInputSearch
                attr.aria-label="{{ searchField.label }}"
                placeholder="{{ searchField.label }}"
                (keyup)="onSearchInputChange($event.target, searchField)"
                (searchEvent)="onSearchClick($event, searchField)"
                (focus)="onSearchFieldFocus($event.target, searchField)"
                (focusOut)="onSearchFieldFocusOut(searchField)"
        />
      </valg-input-group>
    </ng-container>
    <button
      (click)="filterButtonClicked()"
      *ngIf="enableFiltering"
      class="btn-secondary filter_button align-self-center"
      color="nav-solid"
      valgButton>
      <span class="filter_button__icon"><mat-icon [svgIcon]="SvgIcon.Filter"></mat-icon></span>
      <span class="text text--normal filter_button__text">
        {{ (dataSource.activeColumnFilter !== 1 ? "table.filter_text_multiple" : "table.filter_text_single") | translate: { value: dataSource.activeColumnFilter } }}
      </span>
    </button>
    <button
            (click)="printButtonClicked!()"
            *ngIf="showPrintButton"
            id="{{id}}-print"
            class="btn-secondary filter_button align-self-center"
            color="nav-solid"
            valgButton
    >
      <span class="filter_button__icon"><mat-icon [svgIcon]="SvgIcon.Print"></mat-icon></span>
      <span class="text text--normal filter_button__text">{{
        printButtonLabel ? (printButtonLabel | translate) : ("table.print_list" | translate)
      }}</span>
    </button>

    <button
            (click)="refreshButtonClicked()"
            *ngIf="showRefreshButton"
            class="btn-secondary filter_button"
            color="nav-solid"
            valgButton
    >
      <span class="filter_search__icon no-fill"><mat-icon [svgIcon]="SvgIcon.SkiftTwoArrow"></mat-icon></span>

      <span class="text text--normal filter_button__text">{{
        refreshButtonText | translate
        }}</span>
    </button>

    <valg-data-export
      *ngIf="enableExport"
      [canExportHeadersOnly]="canExportHeadersOnly"
      [data]="getProcessedExportData()"
      [filename]="exportFileName"
      [headers]="getExportHeaderData()"
      [buttonText]="exportButtonText"
      [exportFunction]="exportFunction"
      [exportButtonIcon]="exportButtonIcon"
    ></valg-data-export>

    <valg-data-export
      *ngIf="enableExportToPdf && (itemCount > 0)"
      [toPdf]="true"
      [data]="getProcessedExportData()"
      [filename]="exportFileName"
      [headers]="getExportHeaderData()"
      [buttonText]="exportButtonText"
      [exportFunction]="exportFunction"
      [exportButtonIcon]="exportButtonIcon"
    ></valg-data-export>
  </div>
  <div class="table-element">
    <table
      #table
      [class.more-spacing]="columnSpacing"
      (cdkDropListDropped)="onDrop($event)"
      (sortChange)="announceSortChange($event)"
      valgSort
      [dataSource]="dataSource"
      [attr.aria-describedby]="description ? id+'-title '+id+'-description' : id+'-title'"
      cdk-table
      cdkDropList
      cdkDropListLockAxis="y"
      class="table table--zebra w-100"
      [cdkDropListDisabled]="dragDisabled"
      aria-live="polite"
      [attr.aria-atomic]="hasLiveUpdates ? false : null"
      [trackBy]="trackById"
      [attr.aria-rowcount]="dataSource.numberOfitemsOnCurrentPage"
    >
      <!-- Column definitions -->
      <ng-container
        *ngFor="let column of columns; let i = index, let first = first"
        [cdkColumnDef]="column.title"
      >
        <th
          (selectstart)="$event.preventDefault()"
          *cdkHeaderCellDef
          [ngClass]="responsiveClass(column)"
          [class]="column.metadata ? column.metadata.class ?? '' : 'null'"
          scope="col"
          cdk-header-cell
        >
          <valg-sort-header [ngClass]="column.metadata?.rightAligned ? 'header_align_right' : 'header_align_left'" [columnMetadata]="column.metadata">
            <ng-container
              *ngTemplateOutlet="headerCellTemplate; context: { column: column }"
            ></ng-container>
          </valg-sort-header>
        </th>

        <td
          *cdkCellDef="let row"
          cdk-cell
          class="table-content text text--primary"
          [class]="column.metadata ? column.metadata.class ?? '' : 'null'"
          [ngClass]="responsiveClass(column)"
          (click)="row.children ? toggleChildrenRows($event, row) : ''"
        >
          <ng-container
            *ngTemplateOutlet="
              cellTemplate;
              context: { column: column, row: row, first: first }
            "
          ></ng-container>
        </td>
        <ng-container *ngIf="useFooterRow">
          <td
            *cdkFooterCellDef
            cdk-footer-cell

          [ngClass]="responsiveClass(column)"
            class="footer-content text text--primary"
          >
            <ng-container
              *ngTemplateOutlet="
              cellTemplate;
              context: { column: column, row: getFooterData(column), first: first }
            "
            ></ng-container>
          </td>
        </ng-container>
      </ng-container>
      <!--    Options column-->
      <ng-container [cdkColumnDef]="optionColumn.title">
        <th
          (selectstart)="$event.preventDefault()"
          *cdkHeaderCellDef
          cdk-header-cell
          class="option-column"
        >
          <div class="table-header">
            <ng-container
              *ngTemplateOutlet="
                headerCellTemplate;
                context: { column: optionColumn }
              "
            ></ng-container>
          </div>
        </th>

        <td *cdkCellDef="let row" cdk-cell class="option-column">
          <ng-container
            *ngTemplateOutlet="optionCellTemplate; context: { row: row }"
          ></ng-container>
        </td>
        <ng-container *ngIf="useFooterRow">
          <td
            *cdkFooterCellDef
            cdk-footer-cell
            class="footer-content option-column"
          >
          </td>
        </ng-container>
      </ng-container>

      <ng-container [cdkColumnDef]="dragColumn.title">
        <th
          (selectstart)="$event.preventDefault()"
          *cdkHeaderCellDef
          cdk-header-cell
          class="drag-column"
        >
          <span class="sr-only">{{ 'table.drag_drop_column_header' | translate }}</span>
        </th>

        <td *cdkCellDef="let row;let i = index;"
            cdk-cell
            class="drag-column"
        >
          <ng-container
            *ngTemplateOutlet="dragDropCellTemplate; context: { row: row, index: i }"
          ></ng-container>
        </td>
      </ng-container>

      <ng-container [cdkColumnDef]="expansionColumn.title">
        <th
          (selectstart)="$event.preventDefault()"
          *cdkHeaderCellDef
          cdk-header-cell
          class="expansion-column"
        >
          <button type="button" [attr.aria-expanded]="false" class="expandable-button" (click)="toggleAllChildrenRows($event)">
            <mat-icon  [svgIcon]="SvgIcon.PointingDownBracket" class="expandable-icon"></mat-icon>
            <span class="sr-only">{{ 'table.expand_all_button' | translate }}</span>
          </button>
        </th>

        <td *cdkCellDef="let row"
            cdk-cell
        >
          <button *ngIf="row.children?.length> 0"  type="button" [attr.aria-expanded]="isLoadingDone(row)" class="expandable-button" (click)="toggleChildrenRows($event, row)">
            <mat-icon [svgIcon]="SvgIcon.PointingDownBracket" class="expandable-icon"></mat-icon>
            <span class="sr-only">{{ 'table.expand_button' | translate }}</span>
          </button>
        </td>
      </ng-container>
      <!-- Column definitions -->

      <!-- Row definitions -->

      <tr *cdkHeaderRowDef="columnNames" cdk-header-row [class.sr-only]="!useHeaderRow"></tr>
      <tr
        *cdkRowDef="let row; columns: columnNames; let i = index"
        [attr.data-id]="row.id"
        [cdkDragDisabled]="!dragDropEnabled"
        cdk-row
        cdkDrag
        [cdkDragData]="row"
        [class.child-row]="row.children === undefined"
        [class.display-hidden]="row.children === undefined && !isLoadingDone(row)"
        [class.parent-row]="dataSource.hasNestedItems && row.children?.length > 0"
        [class.parent-row__no-children]="dataSource.hasNestedItems && row.children?.length === 0"
        [attr.data-expanded]="isLoadingDone(row)"
        [attr.aria-atomic]="checkIfRowHasUpdates(row) ? true : null"
        [attr.aria-rowindex]="i + 1"
      ></tr>
      <ng-container *ngIf="useFooterRow">
        <tr
          (keydown.space)="$event.preventDefault()"
          *cdkFooterRowDef="columnNames"
          cdk-footer-row
        ></tr>
      </ng-container>
      <tr *cdkNoDataRow>
        <td colspan="100%">
          <div>{{!searchUsed? textNoInitialDataResults ? (textNoInitialDataResults | translate): textNoInitialDataResults : textNoSearchResults}}</div>
        </td>
      </tr>
    </table>
  </div>
  <valg-paginator
    #tablePaginator
    (paginationChanged)="onPaginationChanged($event)"
    *ngIf="hasPagination"
    [showPageSizeMenu]="showPageSizeMenu"
    [pageSize]="itemPerPage"
    [totalItems]="totalItems ?? itemCount"
    class="table_paginator"
  ></valg-paginator>
</div>

<ng-template #headerCellTemplate let-column="column">
    <ng-container *ngIf="!column.metadata?.headerTooltip">
      {{ column.title | translate }}
      {{ column.sortable }} 
    </ng-container>
    <div *ngIf="column.metadata?.headerTooltip">
      <span class="table-title">{{ column.title | translate }}</span>
      <valg-tooltip-button *ngIf="column.metadata.headerTooltip" [tooltip]="column.metadata.headerTooltip" class="table-header-tooltip"></valg-tooltip-button>
    </div>
</ng-template>

<ng-template #cellTemplate let-column="column" let-row="row" let-first="first">
<div class="d-flex cell-presentation-component-wrapper text text--f16" [ngClass]="column.metadata?.rightAligned ? 'value_align_right' : 'value_align_left'" [class.has-child-row-count]="first && shouldShowChildRowCount(row)">
    <ng-container>
      <ng-container
        [valgCellComponentOutletColumn]="column"
        [valgCellComponentOutletRow]="row"
        [valgCellComponentOutlet]="getPresentationComponent(column)"
        valgCellOutlet
      ></ng-container>
    </ng-container>
    <div *ngIf="first && shouldShowChildRowCount(row)" class="text--400 child-row-count" >&nbsp;&#40;{{getChildRowCount(row,column)}}
      {{ (getChildRowCount(row,column) !== 1 ? pluralChildItemName ?? itemName : childItemName ?? itemName) | translate }}&#41;
    </div>
  </div>
</ng-template>

<ng-template #optionCellTemplate let-row="row">
  <ng-container>
    <div class="table-menu-option">
      <valg-table-row-options
        *ngIf="getItemOption(row).length !== 0"
        [data]="row"
        [itemOptions]="getItemOption(row)"
        label="{{'table.option_column'|translate}} {{getAccessibilityId(row)}}">
      </valg-table-row-options>
    </div>
  </ng-container>
</ng-template>

<ng-template #dragDropCellTemplate let-row="row" let-index="index">
  <button
    data-drag-and-drop="true"
    cdkOverlayOrigin
    #overflowOverlayOrigin="cdkOverlayOrigin"
    valgButton
    color="icon-no-highlight"
    (click)="dragAndDropMenu.open()"
    (mousedown)="dragDisabled = false"
    (mouseup)="dragDisabled = true"
    class="drag-and-drop-button"
    #dragAndDropButton
    >
    <mat-icon [svgIcon]="SvgIcon.DragDropIndicator"></mat-icon>
    <span class="sr-only">{{ 'table.drag_drop_button' | translate: {id: getAccessibilityId(row)} }}</span>
  </button>
  <valg-overflow-menu #dragAndDropMenu [origin]="overflowOverlayOrigin" originLabel="data-drag-and-drop">
    <button (click)="moveRowUp(index, dragAndDropMenu)" [class.d-none]="index === 0" [attr.tabindex]="index === 0 ? -1 : 0" valgButton>
      {{ dragDropMoveUpText | translate }}
    </button>
    <button (click)="moveRowDown(index, dragAndDropMenu)" [class.d-none]="index === data.length-1"  [attr.tabindex]="index === data.length - 1 ? -1 : 0" valgButton>
      {{ dragDropMoveDownText | translate }}
    </button>
  </valg-overflow-menu>
</ng-template>
